<template>
  <div id="reset_pin_first_access">
    <div
      v-if="!showFeedbackModal"
      class="block__reset_pin"
    >
      <CardLayoutLogo />
      <div class="change__pin_subtitle">
        Por segurança, você precisa definir um novo PIN antes de continuar. Esta ação foi solicitada
        pelo administrador do sistema.
      </div>
      <div class="change__pin_title">Altere seu PIN</div>
      <div class="rule__options_block">
        <span :class="rule_1 ? 'is-valid' : 'not-valid'"
          ><DotIcon v-if="!rule_1" /><CheckCircleIcon
            v-else
            class="check__icon"
          />
          Deve conter 4 números
        </span>
        <span :class="rule_2 ? 'is-valid' : 'not-valid'"
          ><DotIcon v-if="!rule_2" /><CheckCircleIcon
            v-else
            class="check__icon"
          />
          Não deve ser uma sequência
        </span>
        <span :class="rule_3 ? 'is-valid' : 'not-valid'"
          ><DotIcon v-if="!rule_3" /><CheckCircleIcon
            v-else
            class="check__icon"
          />
          Os PINs devem ser iguais
        </span>
      </div>
      <div class="block__pins_inputs">
        <div
          v-if="showErrorMessage"
          class="block__error_messsage"
        >
          Todos os requisitos devem ser cumpridos
        </div>
        <InputText
          input-i-d="pin-input"
          :vmodel.sync="pin"
          field-label="Novo PIN"
          field-placeholder="Digite aqui seu novo PIN"
          :state="states.pin"
          :invalid-feedback="''"
          input="password"
          max-length="4"
          @change="validatePin"
          @keydown="preventIfKeyIsLetter"
        />
        <InputText
          input-i-d="confirm-pin-input"
          :vmodel.sync="pin_confirm"
          field-label="Repita o Novo PIN"
          field-placeholder="Redigite o novo PIN"
          :state="states.pin_confirm"
          :invalid-feedback="''"
          input="password"
          max-length="4"
          @change="validateEqualPin"
          @keydown="preventIfKeyIsLetter"
        />
      </div>

      <div class="block__footer_buttons">
        <ButtonFullWidth @click="savePin">
          <div slot="text">Salvar PIN</div>
        </ButtonFullWidth>
        <ButtonFullWidth
          button-color="white"
          @click="_logout"
        >
          <div slot="text">Cancelar</div>
        </ButtonFullWidth>
      </div>
    </div>
    <modal-confirm
      v-else
      title="PIN alterado"
      subtitle="Agora você pode acessar sua conta com o novo PIN criado"
      button-text="Ir para MyInd"
      @click="
        $router
          .push({
            name: 'home'
          })
          .catch(() => {})
      "
    />
  </div>
</template>

<script>
  import CardLayoutLogo from '@/views/authentication/components/card-layout/components/indsiders-logo';
  import DotIcon from '@/assets/icons/rule-options-icon.svg';
  import CheckCircleIcon from '@/assets/icons/check-circle-icon.svg';
  import InputText from '@/components/input-text/index.vue';
  import ButtonFullWidth from '@/components/buttons/button-full-width';
  import ModalConfirm from '../modalConfirm.vue';

  export default {
    components: {
      CardLayoutLogo,
      DotIcon,
      CheckCircleIcon,
      InputText,
      ButtonFullWidth,
      ModalConfirm
    },
    data() {
      return {
        pin: '',
        pin_confirm: '',
        rule_1: false,
        rule_2: false,
        rule_3: false,
        showErrorMessage: false,
        showFeedbackModal: false,
        states: {
          pin: null,
          pin_confirm: null
        }
      };
    },
    beforeMount() {
      const userInfo = this.$cookies.get('userInfo');
      if (userInfo.passwordChangeRequired) {
        this.$router.push({ name: 'first-access-reset-password' }).catch(() => {});
      }
      this.showFeedbackModal = !userInfo.pinChangeRequired;
    },
    methods: {
      validatePin() {
        this.rule_1 = this.pin.length === 4;
        this.rule_2 = !!this.pin && !this.checkIfIsNumberSequence(this.pin);
        this.pin_confirm !== '' && (this.rule_3 = this.pin === this.pin_confirm);
      },
      validateEqualPin() {
        this.pin !== '' && (this.rule_3 = this.pin === this.pin_confirm);
      },
      checkIfIsNumberSequence(value) {
        const string = typeof value === Number ? value.toString() : value;
        const listNumber = string.split('').map(Number);
        const length = listNumber.length;

        let isCrescentSequence = true;
        let isDerescentSequence = true;

        if (length <= 1) return false;

        for (let i = 1; i < listNumber.length; i++) {
          if (listNumber[i] !== listNumber[i - 1] + 1) {
            isCrescentSequence = false;
            break;
          }
        }

        for (let i = 1; i < listNumber.length; i++) {
          if (listNumber[i] !== listNumber[i - 1] - 1) {
            isDerescentSequence = false;
            break;
          }
        }

        return isCrescentSequence || isDerescentSequence;
      },
      preventIfKeyIsLetter(event) {
        const input = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'F5'];
        const keyPressed = event.key;
        const keyCode = event.keyCode ?? event.which;

        if (!input.includes(keyPressed) && keyCode != 8) event.preventDefault();
      },
      async savePin() {
        this.showErrorMessage = false;
        const isValid = this.rule_1 && this.rule_2 && this.rule_3;
        this.states.pin = isValid ? null : false;
        this.states.pin_confirm = isValid ? null : false;

        if (!isValid) {
          this.showErrorMessage = true;
          return;
        }

        const payload = {
          pin: this.pin
        };
        const domain = window.location.href.includes('indsiders.com');

        await this.$http2.put(`/api/user/change-pin`, payload).then(() => {
          const userInfo = this.$cookies.get('userInfo');
          this.$cookies.set(
            'userInfo',
            {
              ...userInfo,
              pinChangeRequired: false
            },
            '7D',
            null,
            domain ? 'indsiders.com' : null
          );
          this.showFeedbackModal = true;
        });
      }
    }
  };
</script>

<style lang="scss">
  #reset_pin_first_access {
    min-height: 100dvh;
    width: 100%;
    padding: 37px 18px;
    background-image: url('../../../assets/images/cubos.png');
    background-color: #362f2b;
    background-size: 175px;

    display: flex;
    align-items: center;
    justify-content: center;

    .block__reset_pin {
      display: flex;
      background-color: #fff;
      max-width: 527px;
      padding: 24px;
      flex-direction: column;
      align-items: flex-start;
      border-radius: 6px;
      border: 1px solid #cfc4be;
      box-shadow: 0px 12px 17px 0px rgba(0, 0, 0, 0.14), 0px 5px 22px 0px rgba(0, 0, 0, 0.12),
        0px 7px 8px 0px rgba(0, 0, 0, 0.2);

      .change__pin_subtitle {
        color: #998f8a;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;
        padding-block: 24px;
        text-align: start;
      }

      .change__pin_title {
        color: #4c4541;
        font-size: 28px;
        font-weight: 600;
        line-height: 38px;
        padding-bottom: 8px;
      }

      .rule__options_block {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        padding-bottom: 16px;
        width: 100%;
        border-bottom: 1px solid #eee;

        span {
          display: flex;
          align-items: center;
          text-align: start;
          gap: 8px;
          color: #998f8a;
          font-size: 16px;
          font-weight: 400;
          line-height: 22px;

          .check__icon {
            width: 12px;
            height: 12px;
            path {
              fill: #4caf50;
            }
          }

          &.is-valid {
            color: #4caf50;
          }
        }
      }

      .block__pins_inputs {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding-block: 16px;
        width: 100%;

        .block__error_messsage {
          display: flex;
          padding: 16px;
          align-items: center;
          gap: 16px;
          border-radius: 6px;
          border: 1px solid #b71c1c;
          background: #ffebee;
          color: #b71c1c;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
        }
      }

      .block__footer_buttons {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding-top: 16px;
        width: 100%;
      }

      @media (max-width: 480px) {
        padding-inline: 15px;

        .change__pin_subtitle {
          font-size: 12px;
          line-height: 16px;
          padding-bottom: 16px;
        }

        .change__pin_title {
          font-size: 22px;
          line-height: 30px;
        }

        .rule__options_block {
          gap: 0;
          span {
            font-size: 12px;
            line-height: 16px;
          }
        }

        .block__pins_inputs {
          display: flex;
          flex-direction: column;
          gap: 16px;
          padding-block: 16px;
          width: 100%;

          .block__error_messsage {
            font-size: 12px;
            line-height: 16px;
          }
        }

        .block__footer_buttons {
          padding-top: 8px;
        }
      }
    }
  }
</style>
